<div class="wrapper">
  <canvas #canvas></canvas>
</div>
